export default "__VITE_ASSET__de39e8b0__"